export const INTERNAL_EMAIL_DOMAINS = ["@inkle.io", "@inkle.ai"] as const;
